import React from 'react'
import PropTypes from 'prop-types'
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap'
import { Link } from 'react-router'
import PageTemplate from 'components/page-template'
import Auth from 'services/auth'

const experiences = {
  engagement: [
    {
      title: 'Mentions',
      description:
        'Interact with a Tweet that mentions a predefined handle or hashtag',
      link: '/experiences/create/mentions'
    },
    {
      title: 'Reminder',
      description:
        "Encourage a user to Retweet your Tweet to subscribe them for future Tweets or Direct Messages. It's the simplest way to gain permission to communicate directly with a user on Twitter.",
      link: '/experiences/create/reminder'
    },
    {
      title: 'Photo Mosaic',
      description:
        "Allow users to add their own image as a tile in an interactive photo mosaic. These image tiles make up a large image of the brand's/client's choosing.",
      link: '/experiences/create/mosaic'
    },
    {
      title: 'ThreadVenture',
      description: 'A Thread. But also an Adventure.',
      link: '/experiences/create/twitter_threadventure'
    },
    {
      title: 'Speed Thread',
      description:
        'Scroll through a thread as fast as possible liking Tweets along the way or race to the finish line by liking a first and last Tweet',
      link: '/experiences/create/twitter_speed_thread'
    },
    {
      title: 'Instagram Auto-Response',
      description:
        'Encourage mass engagement on Instagram and reward user participation whilst increasing your audience reach and generating leads.',
      link: '/experiences/create/competition'
    },
    {
      title: 'Facebook Competition',
      description:
        'Encourage mass engagement on Facebook and reward user participation whilst increasing your audience reach and generating leads.',
      link: '/experiences/create/facebook-competition'
    },
    {
      title: 'Facebook Reminder',
      description:
        'Encourage a user to engage with a post to receive consent to opt into one-time branded notifications',
      link: '/experiences/create/facebook-reminder'
    },
    {
      title: 'Facebook Recurring Reminder',
      description:
        'Encourage a user to engage with a post to receive consent to opt into recurring branded notifications',
      link: '/experiences/create/facebook-recurring-reminder'
    },
    {
      title: 'Facebook Coupon',
      description:
        'Encourage a user to engage with a post on Facebook to receive unique coupon codes',
      link: '/experiences/create/facebook_coupon'
    },
    {
      title: 'Instagram Coupon',
      description:
        'Encourage a user to engage with a post on Instagram to receive unique coupon codes',
      link: '/experiences/create/instagram_coupon'
    }
  ],
  interactive: [],
  events: []
}

export const Experience = ({ title, description, link, canCreate }) => (
  <div className='col-sm-4 col-md-6 col-lg-4'>
    <div className='br-base-widget'>
      <div className='br-widget-top'>
        <div className='br-widget-title'>{title}</div>
        <div className='br-widget-description'>{description}</div>
      </div>
      <div className='br-widget-activate-button'>
        <div className='btn-group full-width btn-group-solid'>
          {canCreate ? (
            <Link to={link} className='btn blue'>
              Configure
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  </div>
)

Experience.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  canCreate: PropTypes.bool.isRequired
}

const ExploreExperiences = () => (
  <PageTemplate
    title='Explore Experiences'
    description='engagement, competition and much more'
    className='br-explore-experiences'
  >
    <Tab.Container id='experiences' defaultActiveKey='engagement'>
      <Row className='clearfix'>
        <Col md={3}>
          <Nav bsStyle='pills' stacked>
            <NavItem eventKey='engagement'>Engagement</NavItem>
            {/* Hiding these tabs until we implement the functionality */}
            {/* <NavItem eventKey='interactive'>Interactive</NavItem>
            <NavItem eventKey='events'>Events</NavItem> */}
          </Nav>
        </Col>
        <Col md={9}>
          <Tab.Content animation>
            <Tab.Pane eventKey='engagement'>
              <div className='row'>
                {experiences.engagement.map(e => (
                  <Experience
                    key={e.title}
                    {...e}
                    canCreate={Auth.canCreateWidgets}
                  />
                ))}
              </div>
            </Tab.Pane>
            {/* Hiding these tabs until we implement the functionality */}
            {/* <Tab.Pane eventKey='interactive'>Coming soon</Tab.Pane>
            <Tab.Pane eventKey='events'>Coming soon</Tab.Pane> */}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  </PageTemplate>
)

export default ExploreExperiences



// WEBPACK FOOTER //
// ./src/pages/explore-experiences/index.js